import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Gift, Loader2 } from 'lucide-react';
import BottomNav from '../components/BottomNav';
import { getReceivedGifts } from '../services/api';

const formatDate = (iso) => {
  try {
    const d = new Date(iso);
    const diff = Date.now() - d.getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 60) return `${mins}m ago`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs}h ago`;
    const days = Math.floor(hrs / 24);
    if (days < 7) return `${days}d ago`;
    return d.toLocaleDateString();
  } catch { return ''; }
};

const GiftsReceivedPage = () => {
  const navigate = useNavigate();
  const [gifts, setGifts] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getReceivedGifts()
      .then(r => { setGifts(r.data.gifts || []); setTotal(r.data.total || 0); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-white pb-24" data-testid="gifts-received-page">
      <div className="sticky top-0 z-20 bg-white/95 backdrop-blur-lg border-b border-pink-100">
        <div className="max-w-2xl mx-auto px-4 py-3 flex items-center gap-3">
          <button onClick={() => navigate(-1)} className="p-2 -ml-2 rounded-full hover:bg-pink-50" data-testid="gifts-back-btn">
            <ArrowLeft className="w-5 h-5 text-gray-700" />
          </button>
          <div className="flex-1">
            <h1 className="text-lg font-bold text-gray-900" style={{ fontFamily: 'Outfit' }}>Gifts received</h1>
            <p className="text-xs text-gray-500">{total} total</p>
          </div>
          <div className="w-9 h-9 rounded-full bg-pink-100 flex items-center justify-center">
            <Gift className="w-4 h-4 text-pink-600" />
          </div>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-4 pt-4 space-y-3">
        {loading ? (
          <div className="flex justify-center py-16">
            <Loader2 className="w-8 h-8 text-pink-500 animate-spin" />
          </div>
        ) : gifts.length === 0 ? (
          <div className="text-center py-20" data-testid="gifts-empty">
            <div className="text-5xl mb-3">🎁</div>
            <div className="text-gray-700 font-semibold">No gifts yet</div>
            <div className="text-sm text-gray-500 mt-1">When someone sends you a gift, it will show up here.</div>
          </div>
        ) : (
          gifts.map((g) => (
            <div key={g.gift_tx_id} className="bg-white rounded-2xl p-4 border border-gray-100 flex items-start gap-3" data-testid={`gift-item-${g.gift_tx_id}`}>
              <div className="w-12 h-12 rounded-xl bg-pink-50 flex items-center justify-center text-2xl flex-shrink-0">
                {g.gift_emoji || '🎁'}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-gray-900">{g.gift_name}</div>
                {g.message && <div className="text-sm text-gray-600 mt-0.5 line-clamp-2">“{g.message}”</div>}
                <div className="text-xs text-gray-400 mt-1">{formatDate(g.created_at)}</div>
              </div>
            </div>
          ))
        )}
      </div>

      <BottomNav />
    </div>
  );
};

export default GiftsReceivedPage;
